import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  FormatListBulleted,
  FormatListNumbered,
  FormatAlignLeft,
  FormatAlignCenter,
  FormatAlignRight,
  FormatAlignJustify,
} from "@mui/icons-material";
import { Box, Divider, IconButton } from "@mui/material";
import ReactQuill from "react-quill";
import Quill from "quill";
import ReactDOMServer from "react-dom/server";
import CustomIcon from "library/icon-library";

// --- START: Quill Inline Size Configuration ---
const Size = Quill.import("attributors/style/size");

// Define your desired font sizes in pixels or other units
// These values will be used as inline styles (e.g., style="font-size: 14px;")
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "32px",
  "48px",
  "64px",
  "72px",
];

// Register the Size attributor to use inline styles
Quill.register(Size, true); // The `true` argument ensures it overwrites any existing 'size' attributor
// --- END: Quill Inline Size Configuration ---
// For Font Family (NEW FIX)
const Font = Quill.import("attributors/style/font"); // Import the style attributor for font
// Define your desired font families. These will be applied as inline styles (e.g., style="font-family: Arial, sans-serif;")
// Use generic family names first, followed by specific ones if desired.
Font.whitelist = [
  "Arial",
  "sans-serif", // Generic 'sans-serif' is a good fallback
  "serif", // Generic 'serif'
  "monospace", // Generic 'monospace'
  // Add other specific fonts you want to support, e.g., 'Times New Roman', 'Courier New'
  "Impact", // Example of a specific font
  "Verdana",
];
Quill.register(Font, true); // Register the Font attributor to use inline styles

// For Alignment (NEW FIX)
const Align = Quill.import("attributors/style/align"); // Import the style attributor for align
Align.whitelist = ["left", "center", "right", "justify"]; // Define the valid alignment values
Quill.register(Align, true); // Register the Align attributor to use inline styles

// --- END: Quill Inline Attributor Configurations ---

const quillIcons = Quill.import("ui/icons");

// Default Toolbar Component
const DefaultToolbar = ({
  editorRef,
  borderLessDesign,
  hideItemsInToolbar,
}: {
  editorRef: React.RefObject<ReactQuill>;
  borderLessDesign?: boolean;
  hideItemsInToolbar?: ("left_align" | "center_align" | "right_align")[];
}) => {
  quillIcons["align"][""] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_left" color={"black"} size={"lg"} />,
  );
  quillIcons["align"]["center"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_center" color={"black"} size={"lg"} />,
  );
  quillIcons["align"]["right"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_right" color={"black"} size={"lg"} />,
  );
  quillIcons["list"]["ordered"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="ordered_list" color={"black"} size={"lg"} />,
  );
  quillIcons["list"]["bullet"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="unordered_list" color={"black"} size={"lg"} />,
  );
  quillIcons["bold"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="bold" color={"black"} size={"lg"} />,
  );
  quillIcons["underline"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="underline" color={"black"} size={"lg"} />,
  );
  quillIcons["italic"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="italic" color={"black"} size={"lg"} />,
  );
  quillIcons["justify"] = ReactDOMServer.renderToStaticMarkup(
    <CustomIcon icon="align_justify" color={"black"} size={"lg"} />,
  );
  const getCurrentFormat = () => {
    const editor = editorRef.current?.getEditor();
    return editor ? editor.getFormat() : {};
  };

  const handleFormat = (format: string, value?: any) => {
    const editor = editorRef.current?.getEditor();
    if (!editor) return;

    // For formats that should toggle (bold, italic, underline)
    if (["bold", "italic", "underline"].includes(format)) {
      const currentFormat = getCurrentFormat();
      editor.format(format, !currentFormat[format]);
      return;
    }

    // For list formatting
    if (format === "list") {
      const currentFormat = getCurrentFormat();
      if (currentFormat.list === value) {
        // If already in this list format, remove it
        editor.format("list", false);
      } else {
        // Otherwise apply the new list format
        editor.format("list", value);
      }
      return;
    }

    // For alignment
    if (format === "align") {
      const currentFormat = getCurrentFormat();
      if (currentFormat.align === value) {
        // If already aligned this way, remove alignment
        editor.format("align", false);
      } else {
        // Otherwise apply the new alignment
        editor.format("align", value);
      }
      return;
    }

    // For other formats
    editor.format(format, value);
  };

  // Square button style
  const squareButtonStyle = {
    // border: "1px solid #ddd",
    // backgroundColor: "white",
    // borderRadius: "4px", // Square with slight rounding
    // width: "32px",
    // height: "32px",
    padding: "4px",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.5,
        p: 1,
        border: borderLessDesign ? "none" : "1px solid #e0e0e0",
        // backgroundColor: "#f5f5f5",
        alignItems: "center",
      }}
    >
      {/* Font family */}
      {/* <Box sx={{ minWidth: 120 }}>
        <select
          onChange={(e) => handleFormat("font", e.target.value)}
          style={{
            padding: "6px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "white",
          }}
        >
          <option value="sans-serif">Sans Serif</option>
          <option value="serif">Serif</option>
          <option value="monospace">Monospace</option>
        </select>
      </Box> */}
      {/* Font family */}
      {/* <Box sx={{ minWidth: 120 }}>
        <select
          onChange={(e) => handleFormat("font", e.target.value)}
          style={{
            padding: "6px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "white",
          }}
        >
          <option value="sans-serif">Sans Serif</option>
          <option value="serif">Serif</option>
          <option value="monospace">Monospace</option>
          <option value="Arial">Arial</option> 
          <option value="Impact">Impact</option> 
          <option value="Verdana">Verdana</option> 
        </select>
      </Box> */}

      {/* Font size */}
      {/* <Box sx={{ minWidth: 100 }}>
        <select
          onChange={(e) => handleFormat("size", e.target.value)}
          style={{
            padding: "6px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "white",
          }}
        >
          <option value="small">Small</option>
          <option value="">Normal</option>
          <option value="large">Large</option>
          <option value="huge">Huge</option>
        </select>
      </Box> */}
      {/* Font size */}
      {/* <Box sx={{ minWidth: 100 }}>
        <select
          onChange={(e) => handleFormat("size", e.target.value)}
          style={{
            padding: "6px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "white",
          }}
        >
          <option value="10px">Smallest</option>
          <option value="12px">Smaller</option>
          <option value="14px">Small</option>
          <option value="16px">Normal</option>{" "}
          <option value="18px">Large</option>
          <option value="20px">Larger</option>
          <option value="24px">Huge</option>
          <option value="32px">Massive</option>
        </select>
      </Box> */}

      {/* Text formatting buttons */}
      <IconButton
        onClick={() => handleFormat("bold")}
        title="Bold"
        sx={squareButtonStyle}
      >
        {/* <FormatBold fontSize="small" />
         */}
        <CustomIcon icon="bold" color={"black"} size={"lg"} />
      </IconButton>

      <IconButton
        onClick={() => handleFormat("italic")}
        title="Italic"
        sx={squareButtonStyle}
      >
        {/* <FormatItalic fontSize="small" /> */}
        <CustomIcon icon="italic" color={"black"} size={"lg"} />
      </IconButton>

      <IconButton
        onClick={() => handleFormat("underline")}
        title="Underline"
        sx={squareButtonStyle}
      >
        {/* <FormatUnderlined fontSize="small" /> */}
        <CustomIcon icon="underline" color={"black"} size={"lg"} />
      </IconButton>
      <Divider orientation="vertical" flexItem />

      {/* List buttons */}
      <IconButton
        onClick={() => handleFormat("list", "bullet")}
        title="Bullet List"
        sx={squareButtonStyle}
      >
        {/* <FormatListBulleted fontSize="small" /> */}
        <CustomIcon icon="unordered_list" color={"black"} size={"lg"} />
      </IconButton>

      <IconButton
        onClick={() => handleFormat("list", "ordered")}
        title="Numbered List"
        sx={squareButtonStyle}
      >
        {/* <FormatListNumbered fontSize="small" /> */}
        <CustomIcon icon="ordered_list" color={"black"} size={"lg"} />
      </IconButton>

      <Divider orientation="vertical" flexItem />

      {/* Alignment buttons */}
      {!hideItemsInToolbar?.includes("left_align") && (
        <IconButton
          onClick={() => handleFormat("align", "left")}
          title="Align Left"
          sx={squareButtonStyle}
        >
          {/* <FormatAlignLeft fontSize="small" /> */}
          <CustomIcon icon="align_left" color={"black"} size={"lg"} />
        </IconButton>
      )}
      {!hideItemsInToolbar?.includes("center_align") && (
        <IconButton
          onClick={() => handleFormat("align", "center")}
          title="Align Center"
          sx={squareButtonStyle}
        >
          {/* <FormatAlignCenter fontSize="small" /> */}
          <CustomIcon icon="align_center" color={"black"} size={"lg"} />
        </IconButton>
      )}
      {!hideItemsInToolbar?.includes("right_align") && (
        <IconButton
          onClick={() => handleFormat("align", "right")}
          title="Align Right"
          sx={squareButtonStyle}
        >
          <CustomIcon icon="align_right" color={"black"} size={"lg"} />
        </IconButton>
      )}
      {/* <IconButton
        onClick={() => handleFormat("align", "justify")}
        title="Justify"
        sx={squareButtonStyle}
      >
        <CustomIcon icon="align_center_content" color={"black"} size={"lg"} />
      </IconButton> */}
    </Box>
  );
};
{
  /* <FormatAlignJustify fontSize="small" /> */
}
export default DefaultToolbar;

// import {
//   FormatBold,
//   FormatItalic,
//   FormatUnderlined,
//   FormatListBulleted,
//   FormatListNumbered,
//   FormatAlignLeft,
//   FormatAlignCenter,
//   FormatAlignRight,
//   FormatAlignJustify,
// } from "@mui/icons-material";
// import { Box, IconButton } from "@mui/material";
// import ReactQuill from "react-quill";

// // Default Toolbar Component
// const DefaultToolbar = ({
//   editorRef,
// }: {
//   editorRef: React.RefObject<ReactQuill>;
// }) => {
//   const handleFormat = (format: string, value?: string) => {
//     const editor = editorRef.current?.getEditor();
//     if (editor) {
//       editor.format(format, value || (format === "align" ? "" : true));
//     }
//   };

//   // Square button style
//   const squareButtonStyle = {
//     border: "1px solid #ddd",
//     backgroundColor: "white",
//     borderRadius: "4px", // Square with slight rounding
//     width: "32px",
//     height: "32px",
//     padding: "4px",
//     "&:hover": {
//       backgroundColor: "#f0f0f0",
//     },
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexWrap: "wrap",
//         gap: 0.5,
//         p: 1,
//         border: "1px solid #e0e0e0",
//         backgroundColor: "#f5f5f5",
//         alignItems: "center",
//       }}
//     >
//       {/* Font family */}
//       <Box sx={{ minWidth: 120 }}>
//         <select
//           onChange={(e) => handleFormat("font", e.target.value)}
//           style={{
//             padding: "6px 8px",
//             borderRadius: "4px",
//             border: "1px solid #ccc",
//             backgroundColor: "white",
//           }}
//         >
//           <option value="sans-serif">Sans Serif</option>
//           <option value="serif">Serif</option>
//           <option value="monospace">Monospace</option>
//         </select>
//       </Box>

//       {/* Font size */}
//       <Box sx={{ minWidth: 100 }}>
//         <select
//           onChange={(e) => handleFormat("size", e.target.value)}
//           style={{
//             padding: "6px 8px",
//             borderRadius: "4px",
//             border: "1px solid #ccc",
//             backgroundColor: "white",
//           }}
//         >
//           <option value="small">Small</option>
//           <option value="">Normal</option>
//           <option value="large">Large</option>
//           <option value="huge">Huge</option>
//         </select>
//       </Box>

//       {/* Text formatting buttons */}
//       <IconButton
//         onClick={() => handleFormat("bold")}
//         title="Bold"
//         sx={squareButtonStyle}
//       >
//         <FormatBold fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("italic")}
//         title="Italic"
//         sx={squareButtonStyle}
//       >
//         <FormatItalic fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("underline")}
//         title="Underline"
//         sx={squareButtonStyle}
//       >
//         <FormatUnderlined fontSize="small" />
//       </IconButton>

//       {/* List buttons */}
//       <IconButton
//         onClick={() => handleFormat("list", "bullet")}
//         title="Bullet List"
//         sx={squareButtonStyle}
//       >
//         <FormatListBulleted fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("list", "ordered")}
//         title="Numbered List"
//         sx={squareButtonStyle}
//       >
//         <FormatListNumbered fontSize="small" />
//       </IconButton>

//       {/* Alignment buttons */}
//       <IconButton
//         onClick={() => handleFormat("align", "")}
//         title="Align Left"
//         sx={squareButtonStyle}
//       >
//         <FormatAlignLeft fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("align", "center")}
//         title="Align Center"
//         sx={squareButtonStyle}
//       >
//         <FormatAlignCenter fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("align", "right")}
//         title="Align Right"
//         sx={squareButtonStyle}
//       >
//         <FormatAlignRight fontSize="small" />
//       </IconButton>

//       <IconButton
//         onClick={() => handleFormat("align", "justify")}
//         title="Justify"
//         sx={squareButtonStyle}
//       >
//         <FormatAlignJustify fontSize="small" />
//       </IconButton>
//     </Box>
//   );
// };

// export default DefaultToolbar;
